import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import type { CalendarPost, CalendarSong } from '../types';
import { PlatformTile } from './PlatformTile';
import { postThumbUrl } from './calendarPostView';
import { calendarMessages } from './calendarMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Calendar; each part uses its own slice of it */
import styles from './PromoteCalendar.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PostThumbProps {
  post: CalendarPost;
  song: CalendarSong | undefined;
  size?: 'sm' | 'md';
}

/** The media thumbnail of a post with the platform tile on its corner (design a1). */
const PostThumbComponent: React.FC<PostThumbProps> = ({ post, song, size = 'sm' }) => {
  const intl = useIntl();
  const url = postThumbUrl(post, song);
  return (
    <span className={clsx(styles.thw, size === 'md' && styles.thwMd)} aria-hidden="true">
      {url === null ? (
        <span className={clsx(styles.th, styles.thText)}>{intl.formatMessage(calendarMessages.textPost)}</span>
      ) : (
        <img className={styles.th} src={url} alt="" loading="lazy" />
      )}
      <PlatformTile platform={post.platform} className={styles.thwTile} />
    </span>
  );
};

export const PostThumb = TypedMemo(PostThumbComponent);
